<template>
    <v-container fluid class="pl-0">
        <v-row>
            <v-col>
                <v-data-table
                    :headers="archivingHeaders"
                    :items="item.archiveRows"
                    :header-props="{ sortIcon: '' }"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    class="noMinWidth"
                >
                <!-- Archiving alvqas -->
                    <template v-for="(header, i) in archivingHeaders" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                <!-- Items -->
                    <template v-slot:[`item.archivePeriod`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-period'">
                            {{ 
                                item.archivePeriod === null ?
                                $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') :
                                $alvPlugin.displayPeriod(item.archivePeriod) 
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.forward`]="{ item }">
                        <div v-if="item.forward !== null">
                            <BaseTooltip>
                                <template v-slot:content>
                                    <v-chip
                                        small
                                        :color="item.forward !== null ? 'standard' : 'standardBrownIcon'"
                                        :alvqa="alvqa + '-archive-' + item.id + '-chip-carry-forward'"
                                    >
                                        {{ 
                                            item.forward !== null ? $t("lang_GENERIC_CAPTION_WITH_CARRY_FORWARD") : $t("lang_GENERIC_CAPTION_WITHOUT_CARRY_FORWARD")
                                        }}
                                    </v-chip>
                                </template>
                                <template v-slot:text :alvqa="alvqa">
                                    <span>{{ $alvPlugin.formatMoney(item.forward) + ' ' + getCurrentCurrency}}</span>
                                </template>
                            </BaseTooltip>
                        </div>
                        <div v-else>
                            <v-chip
                            small
                            :color="item.forward ? 'standard' : 'standardBrownIcon'"
                            :alvqa="alvqa + '-archive-' + item.id + '-chip-carry-forward'"
                        >
                            {{ 
                                item.forward ? $t("lang_GENERIC_CAPTION_WITH_CARRY_FORWARD") : $t("lang_GENERIC_CAPTION_WITHOUT_CARRY_FORWARD")
                            }}
                        </v-chip>
                        </div>
                    </template>

                    <template v-slot:[`item.net`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-net'">
                            {{ 
                                item.net !== null ?
                                    $alvPlugin.formatMoney(item.net) :
                                    ( item.archivePeriod === null ?
                                        $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : $alvPlugin.formatMoney(0)
                                    )
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.vatValue`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-vat-value'">
                            {{ 
                                item.vatValue !== null ?
                                    $alvPlugin.formatMoney(item.vatValue) :
                                    ( item.archivePeriod === null ?
                                        $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : $alvPlugin.formatMoney(0)
                                    )
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.taxWaiver`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-tax-waiver'">
                            {{ 
                                item.taxWaiver !== null ?
                                    $alvPlugin.formatMoney(item.taxWaiver) :
                                    ( item.archivePeriod === null ?
                                        $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : $alvPlugin.formatMoney(0)
                                    )
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.sum`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-sum'">
                            {{ 
                                item.sum !== null ?
                                    $alvPlugin.formatMoney(item.sum) :
                                    ( item.archivePeriod === null ?
                                        $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : $alvPlugin.formatMoney(0)
                                    )
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.creditNumber`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-credit-number'">
                            {{ 
                                item.creditNumber === null ? 
                                    $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : item.creditNumber 
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.archivedOn`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-archiving-date'">
                            {{ item.archivedOn !== null ? $d(new Date(item.archivedOn), 'alvDateTime',  $i18n.locale) : '' }}
                        </div>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <BaseIcon 
                            @click.stop="deleteArchiveLine(item)"
                            icon="delete"
                            color="#d1d1d1"
                            tooltipText="lang_GENERIC_CAPTION_DELETE"
                            :alvqa="alvqa + '-archive-' + item.id + '-icon-delete'"
                        />
                    </template>
                    <template v-slot:[`item.path`]="{ item }">
                        <BaseIcon 
                            v-if="item.path !== null"
                            @click.stop="downloadFile(item.path)"
                            icon="cloud_download"
                            tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                            :alvqa="alvqa + '-archive-' + item.id + '-icon-download'"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
  
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import api from '@/api_alv'

export default {
    name: "PublishingStatementsReadOnly",
    props: {
        itemId: {
            type: Number
        }
    },
    components: {
        BaseIcon,
        BaseTooltip
    },
    data() {
        return {
            alvqa: 'publishing-statements-list-row-' + this.itemId + '-read-only'
        }
    },
        computed: {
        item() {
            let item = this.$store.getters.getExpandedPublishingStatements.find(element => element.id === this.itemId)
            return item
        },
        getCurrentCurrency(){
            return this.$store.getters.getSelectedCurrency
        },

        archivingHeaders() {
            return [
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_ARCHIVE_PERIOD"), 
                    value: 'archivePeriod', 
                    align: 'left', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "140px",
                    alvqa: this.alvqa + '-archive-header-period'
                },
                {
                    text: '', 
                    value: 'forward',
                    align: 'left',
                    sortable: false,
                    width: "170px",
                    // class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_NET') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'net',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-archive-header-net'
                },
                {
                    text: this.$t('lang_GENERIC_STATEMENTS_CAPTION_UST') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'vatValue',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-archive-header-net'
                },
                {
                    text: this.$t('lang_GENERIC_STATEMENTS_CAPTION_TAX_WAIVER') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'taxWaiver',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-archive-header-net'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_GROSS') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'sum',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-archive-header-sum'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_CREDIT_NUMBER'), 
                    value: 'creditNumber',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "190px",
                    alvqa: this.alvqa + '-archive-header-credit-number'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_ARCHIVED_ON'), 
                    value: 'archivedOn',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "200px",
                    alvqa: this.alvqa + '-archive-header-archived-on'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    // class: 'text-no-wrap'
                },
				{
					text: '', 
					value: 'ghost',
					sortable: false,
                    // width: "1%",
                    class: 'text-no-wrap'
				},
                {
                    text: '', 
                    value: 'path',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    // class: 'text-no-wrap'
                }
            ]
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {

        deleteArchiveLine(item) {
            // to reload the readonly view after deleting the archive line, we need the alvid of the statement.
            let statementAlvId
            this.$store.getters.getExpandedPublishingStatements.forEach(element => {
                if(element.id === this.itemId) statementAlvId = element.alvId
            });
            this.$store.commit('setSelectedPublishingStatementsForDeleteArchive', statementAlvId)
            this.$store.commit('setSelectedPublishingStatementsArchive', item)
            this.$store.commit('setDeletionDialogContext', 'SelectedPublishingStatementsArchive')
            this.$store.commit('setShowDeletionDialog', true)
        },

        downloadFile(path) {
            api.getFileFromALV(path)
        }
    }

}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>